import { render } from "./full_orthopedic_head.vue?vue&type=template&id=ad06af88&scoped=true"
import script from "./full_orthopedic_head.vue?vue&type=script&lang=js"
export * from "./full_orthopedic_head.vue?vue&type=script&lang=js"

import "./full_orthopedic_head.vue?vue&type=style&index=0&id=ad06af88&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad06af88"]])

export default __exports__